<template>
  <div class="relative">
    <swiper
      :slides-per-view="1"
      :space-between="20"
      :breakpoints="{
        640: { slidesPerView: 1, spaceBetween: 20 },
        768: { slidesPerView: 2, spaceBetween: 25 },
        1024: { slidesPerView: 3, spaceBetween: 30 }
      }"
      :keyboard="{ enabled: true }"
      :pagination="{ clickable: true, dynamicBullets: true }"
      :navigation="{ nextEl: '.swiper-button-next-custom', prevEl: '.swiper-button-prev-custom' }"
      :modules="modules"
      :autoplay="{ delay: 5000, disableOnInteraction: false }"
      class="testimonials-swiper !pb-16"
    >
      <swiper-slide v-for="(item, index) in testimonials" :key="index" class="!h-auto">
        <div class="h-full bg-white rounded-2xl p-6 md:p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 flex flex-col">
          <div class="mb-4">
            <svg class="w-10 h-10 text-[#009B9D]/20" fill="currentColor" viewBox="0 0 32 32">
              <path d="M10 8c-3.3 0-6 2.7-6 6v10h10V14H6c0-2.2 1.8-4 4-4V8zm14 0c-3.3 0-6 2.7-6 6v10h10V14h-8c0-2.2 1.8-4 4-4V8z"/>
            </svg>
          </div>
          <p class="text-gray-600 italic leading-relaxed flex-grow text-sm md:text-base">"{{ item.content }}"</p>
          <div class="mt-6 flex items-center space-x-3 pt-4 border-t border-gray-100">
            <div class="w-12 h-12 rounded-full bg-gradient-to-br from-[#009B9D] to-[#007a7c] flex items-center justify-center text-white font-bold text-sm shadow-md">{{ item.surname }}</div>
            <div>
              <h4 class="font-semibold text-gray-900">{{ item.author }}</h4>
              <p class="text-sm text-gray-500">{{ item.role }}</p>
            </div>
          </div>
          <div class="mt-4 flex space-x-1">
            <svg v-for="star in 5" :key="star" class="w-4 h-4 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
            </svg>
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <div class="flex justify-center items-center space-x-4 mt-6">
      <button class="swiper-button-prev-custom w-12 h-12 rounded-full border-2 border-[#009B9D] flex items-center justify-center text-[#009B9D] hover:bg-[#009B9D] hover:text-white transition-all duration-300">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/></svg>
      </button>
      <span class="text-sm text-gray-500">{{ $t('testimonials.previous') }} / {{ $t('testimonials.next') }}</span>
      <button class="swiper-button-next-custom w-12 h-12 rounded-full border-2 border-[#009B9D] flex items-center justify-center text-[#009B9D] hover:bg-[#009B9D] hover:text-white transition-all duration-300">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/></svg>
      </button>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import { Keyboard, Pagination, Navigation, Autoplay } from 'swiper/modules'

export default {
  name: 'SwiperComponent',
  components: { Swiper, SwiperSlide },
  data() {
    return {
      testimonials: [
        {
          surname: 'PN',
          author: 'Paul Nguema',
          role: 'Gérant - Pressing Excellence, Douala',
          content: 'Depuis que j\'utilise Kline, j\'ai réduit mes erreurs de commande de 80%. Mes clients adorent pouvoir suivre leur linge en temps réel.'
        },
        {
          surname: 'AM',
          author: 'Aminata Mbarga',
          role: 'Gérante - Clean Express, Yaoundé',
          content: 'L\'application client a transformé mon business. Mes clients commandent maintenant depuis chez eux et je reçois tout automatiquement.'
        },
        {
          surname: 'JT',
          author: 'Jean Tchinda',
          role: 'Gérant - Pressing du Centre, Douala',
          content: 'Le support est exceptionnel. L\'équipe Kline m\'a aidé à configurer tout en moins d\'une journée. Je recommande à tous les pressings.'
        },
        {
          surname: 'SE',
          author: 'Sophie Ekambi',
          role: 'Gérante - Pressing Premium, Bafoussam',
          content: 'Avec le module livraison, j\'ai pu étendre ma zone de service. Mon chiffre d\'affaires a augmenté de 40% en 3 mois.'
        },
        {
          surname: 'MN',
          author: 'Michel Nkoulou',
          role: 'Gérant - Multi-Pressing, Douala',
          content: 'Je gère 3 établissements depuis une seule interface. Les statistiques me permettent de prendre de meilleures décisions.'
        }
      ]
    }
  },
  setup() {
    return { modules: [Keyboard, Pagination, Navigation, Autoplay] }
  }
}
</script>

<style>
.testimonials-swiper .swiper-pagination-bullet { background-color: #009B9D; opacity: 0.3; transition: all 0.3s ease; }
.testimonials-swiper .swiper-pagination-bullet-active { opacity: 1; transform: scale(1.2); }
.testimonials-swiper .swiper-slide { height: auto; }
</style>